import { createSignal } from "solid-js";
import * as styles from "./css/PauseScreen.module.css";
import { Backdrop, VersionInfo } from "@gui/components";
import PauseHome, { Settings } from "./screens";
const PauseScreen = () => {
    const SCREEN = {
        home: <PauseHome goToSettings={() => setCurrentTabName("settings")}/>,
        settings: <Settings onGoBack={() => setCurrentTabName("home")}/>,
    };
    const [currentTabName, setCurrentTabName] = createSignal("home");
    return (<Backdrop centered dark>
            {[SCREEN[currentTabName()]]}
            <footer class={styles.footerLeft}>
                <VersionInfo />
            </footer>
        </Backdrop>);
};
export default PauseScreen;
